import Mutations from '../../odata/mutations';

export default { ...new Mutations('industry'), ...new Mutations('industries') };
